<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ack-title"><a id="pagevii">Acknowledgements</a></h2><a id="pagevii">
</a><p class="noindent"><a id="pagevii"><span class="dropcap">N</span>o book is the work of one person alone. This book certainly is not and that is why I must thank the following for their assistance and generosity: without them it would be a much diminished work. Thanks to, in no particular order, Mark Sessions and W. K. Sessions for permission to use images published in <em class="italic">The Tukes of York</em>: Nicholas Melia at the Borthwick Institute for Archives, University of York, for the Joseph Rowntree Foundation photographs and allowing access to numerous other primary sources; Raoul Guise and his excellent website; Dr Catherine Oakley, executive secretary at The Rowntree Society; Michael and Ian Collinson for permission to quote from the Pavement shop ledger book; Laura Yeoman, archivist (access and engagement) at Explore York Libraries and Archives, York Explore Library Learning Centre. Thanks too to John Lazenby, grandson of Percy Lazenby, for filling a gap in our industrial history which few knew even existed when he provided information on the elusive Lazenby &amp; Son (York) Ltd. I am also grateful to Sue Major, John Stevens and Mavis Morris of Clements Hall Historical Society for permission to use their research on York Confectionery Company and H. Backhouse &amp; Co.</a><a id="pageviii"></a></p><a id="pageviii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?5a7ccd9d